import React from 'react';
import { styled } from 'styled-components';
import { breakpoints } from '../../abstracts';
import { Button } from '../Button';
import { dontForwardProps } from '../../util';
export const ButtonContainer = styled.div.withConfig({
  componentId: "aui__sc-1pd5z30-0"
})(["margin-top:var(--aui-spacing-200);display:flex;flex-direction:row;width:100%;flex-wrap:wrap;gap:var(--aui-spacing-200);"]);
export const MediaWrapper = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1pd5z30-1"
})(["margin-left:var(--aui-spacing-200);> *:first-of-type{", "}"], props => props.hasIcon ? `
          height: 4rem;
          width: 4rem;

          ${breakpoints.md} {
            height: 5rem;
            width: 5rem;
          }
        ` : `
          height: 5rem;
          width: 5rem;

          ${breakpoints.md} {
            height: 6.5rem;
            width: 6.5rem;
          }
        `);
export const CalloutElement = styled.div.withConfig({
  componentId: "aui__sc-1pd5z30-2"
})(["font-style:normal;padding:var(--aui-spacing-200);display:flex;flex-direction:column;justify-content:center;align-items:flex-start;border-style:solid;border-width:var(--aui-stroke-card);border-radius:var(--aui-border-radius-100);background-color:var(--aui-surface-variant);border-color:var(--aui-outline-soft);color:var(--aui-on-surface);letter-spacing:0;width:auto;"]);

/* 
  In the case of a ton of text in a button,
*/
export const CalloutButton = styled(Button).withConfig({
  componentId: "aui__sc-1pd5z30-3"
})(["max-width:100%;overflow:hidden;&:not(:last-child){margin-right:calc(-1 * var(--aui-spacing-100));}"]);
export const CalloutHeading = styled.div.withConfig({
  componentId: "aui__sc-1pd5z30-4"
})(["font-size:1.25rem;font-weight:bold;line-height:130%;width:100%;text-align:left;margin-bottom:var(--aui-spacing-100);"]);
export const CalloutContentComponent = props => {
  const {
    compressionEnabled,
    isCompressed,
    content,
    compressLineLimit
  } = props;
  return /*#__PURE__*/React.createElement(CalloutContent, {
    isCompressed: compressionEnabled && isCompressed,
    lineLimit: compressLineLimit
  }, content);
};
export const ButtonLink = styled(Button).withConfig({
  componentId: "aui__sc-1pd5z30-5"
})(["&.asurion-ui-callout-compression-button{border:none;padding:0;}"]);
const CalloutContent = styled.p.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1pd5z30-6"
})(["color:var(--aui-on-surface-soft);font-size:1rem;line-height:130%;margin:0;text-align:left;white-space:break-spaces;width:100%;", " display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;"], props => props.isCompressed && `-webkit-line-clamp: ${props.lineLimit};`);
export const TopContainer = styled.div.withConfig({
  componentId: "aui__sc-1pd5z30-7"
})(["display:flex;justify-content:space-between;width:100%;word-break:break-word;"]);